// Pages under the help center (/help). Used by the site header's Help
// dropdown and, opening in a new tab, by the dashboard sidebar pop-out, the
// user menu submenu and dashboard search.
export const HELP_CENTER_LINKS = [
  {
    label: 'Documentation',
    description: 'Guides for every part of your page, from links to custom domains.',
    icon: 'i-lucide-book-open',
    to: '/docs/getting-started'
  },
  {
    label: 'Suggestions',
    description: 'Share ideas and vote on what we build next.',
    icon: 'i-lucide-lightbulb',
    to: '/suggestions'
  }
] as const
